import { defineStyleConfig } from "@chakra-ui/react";

const Input = defineStyleConfig({
  variants: {
    outline: {
      field: {
        borderColor: "neutrals.stroke.soft-200",
        backgroundColor: "neutrals.background.white-0",
        _focus: {
          borderColor: "neutrals.text.strong-950",
          boxShadow: "none",
        },
        _disabled: {
          color: "neutrals.text.strong-950",
          backgroundColor: "neutrals.background.weak-50",
          borderColor: "neutrals.stroke.soft-200",
        },
      },
    },
  },
  defaultProps: {
    variant: "outline",
  },
});

export default Input;
